window.addEventListener('load', () => {
    const stickyCta = document.querySelector('.sticky-cta');
    let personalisationInputWrapper = document.querySelector('.bold_options');
    let boldOptions = true;
    if (document.querySelector('.product-personalizer')) {
        personalisationInputWrapper = document.querySelector('.product-personalizer')
        boldOptions = false;
    }
    const variantSelector = document.querySelector('.option-selectors')
    if (variantSelector) {
        personalisationInputWrapper = variantSelector
    }
    if (!personalisationInputWrapper) {
        personalisationInputWrapper = document.querySelector('.product-description');
    }
    const accordionReveal = document.querySelector('.accordian-reveal');

    stickyCta.addEventListener('click', (e) => {
        e.preventDefault()
        const optionAccordion = document.querySelector('#option-accordian')
        if (optionAccordion) {
            optionAccordion.style.height = 'unset';
        }
        if (accordionReveal) {
            accordionReveal.remove();
        }
        if (boldOptions) {
            const boldOptions = document.querySelector('.bold_option_element');
            boldOptions.firstChild.focus();
        }
        window.scrollTo(0, 0);
        const header = document.querySelector('#shopify-section-header');
        const headerHeight = header.offsetHeight;
        window.scrollTo(0, personalisationInputWrapper.getBoundingClientRect().top - headerHeight);


    })

    const showStickyCTA = (bool) => {
        stickyCta.classList.toggle('hide', bool);
        document.querySelector('body').style.marginBottom = `${stickyCta.offsetHeight}px`
    }

    const optionsObserverCallback = (entries) => {
        entries.forEach(entry => {
            showStickyCTA(entry.isIntersecting)
        })
    }
    const optionsObserverOptions = {
        rootMargin: '-50px'
    }

    const optionsIntersectionObserver = new IntersectionObserver(optionsObserverCallback, optionsObserverOptions);

    optionsIntersectionObserver.observe(personalisationInputWrapper);
})